import React from 'react'
import { withRouter } from 'react-router-dom'
import { withMsal } from '@azure/msal-react'
import AuthenticatedHeader from '../components/AuthenticatedHeader'
import FileExLogo from '../components/FileExLogo'
import Spinner from '../components/Spinner'
import Button from '../DMGComponents/Button'
import AdminAreas from '../components/admin/AdminAreas'
import AdminSearchLogs from '../components/admin/AdminSearchLogs'
import AdminUsers from '../components/admin/AdminUsers'
import { checkAdminStatus } from '../fetchData'
import { isDMGUser } from '../authProvider'
import toast, { Toaster } from 'react-hot-toast'

const TABS = {
    AREAS: 'areas',
    LOGS: 'logs',
    USERS: 'users',
}

class AdminPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            adminStatus: null,
            isLoading: true,
            activeTab: TABS.AREAS,
        }
    }

    componentDidMount() {
        if (!isDMGUser()) {
            this.setState({ isLoading: false })
            return
        }
        checkAdminStatus().then(status => {
            this.setState({ adminStatus: status, isLoading: false })
        }).catch(() => {
            toast.error('Error checking admin status.')
            this.setState({ isLoading: false })
        })
    }

    isAdmin = () => {
        const { adminStatus } = this.state
        return adminStatus && (adminStatus.isItAdmin || adminStatus.isManager)
    }

    render() {
        const { isLoading, adminStatus, activeTab } = this.state
        const appSettings = this.props.appSettings || {}

        return (
            <div>
                <Toaster />
                <AuthenticatedHeader isUsaVersion={appSettings.isUsaVersion} isAdminPage={true} history={this.props.history} />
                <FileExLogo clicked={() => this.props.history.push('/')} />

                {isLoading &&
                    <div style={{ textAlign: 'center', marginTop: '32px' }}><Spinner /></div>
                }

                {!isLoading && !isDMGUser() &&
                    <p>Administration is restricted to DMG MORI employees.</p>
                }

                {!isLoading && isDMGUser() && !this.isAdmin() &&
                    <p>You do not have administration permissions.</p>
                }

                {!isLoading && this.isAdmin() &&
                    <div style={{ textAlign: 'left', marginTop: '16px' }}>
                        {/* Tab bar */}
                        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', borderBottom: '1px solid #ccc', paddingBottom: '8px' }}>
                            <Button
                                type={activeTab === TABS.AREAS ? 'default' : 'hover-bottom-left'}
                                onClick={() => this.setState({ activeTab: TABS.AREAS })}>
                                Areas
                            </Button>
                            <Button
                                type={activeTab === TABS.LOGS ? 'default' : 'hover-bottom-left'}
                                onClick={() => this.setState({ activeTab: TABS.LOGS })}>
                                Search Logs
                            </Button>
                            {adminStatus.isItAdmin &&
                                <Button
                                    type={activeTab === TABS.USERS ? 'default' : 'hover-bottom-left'}
                                    onClick={() => this.setState({ activeTab: TABS.USERS })}>
                                    Users
                                </Button>
                            }
                        </div>

                        {/* Tab content */}
                        {activeTab === TABS.AREAS && <AdminAreas />}
                        {activeTab === TABS.LOGS && <AdminSearchLogs />}
                        {activeTab === TABS.USERS && adminStatus.isItAdmin && <AdminUsers />}
                    </div>
                }
            </div>
        )
    }
}

const firstHOC = withRouter(AdminPage)
export default withMsal(withRouter(firstHOC))
